export const de = {
  __currency_code__: "EUR",
  __currency__: "EUR",
  __currency_symbol__: "€",
  __locale__: "de-DE",

  "2d": "2D",
  "3d": "3D",
  viewMode2dPlan: "2D-Plan",
  viewMode3dView: "3D-Ansicht",
  viewModeToggleLabel: "Ansichtsmodus",
  fitCameraTip: "An Szene anpassen",
  zoomIn: "Vergrößern",
  zoomOut: "Verkleinern",
  grid: "Raster",
  rapidPlanner: "RapidPlanner",

  //SugarModelViewer / material panel
  viewerCustomize: "Anpassen",
  viewerPartFabricSelection: "Teil- & Stoffauswahl",
  viewerPanelNote:
    "Die endgültige Farbe kann je nach Produktionscharge variieren. Bitte fordern Sie über die Schaltfläche „Angebot anfordern“ ein Muster an.",
  viewerClose: "Schließen",
  viewerAR: "AR",
  viewerQrTitle: "Zu Hause ansehen",
  viewerQrInformText:
    "*Um diese Funktion nutzen zu können, benötigen Sie ein Smartphone mit Augmented Reality-Unterstützung.*",
  viewer3dDownload: "3D herunterladen",
  viewerGetQuote: "Angebot anfordern",
  viewerToolbar: {
    materials: "Materialien",
    dimensions: "Maße",
    help: "Hilfe",
    gallery: "Galerie",
    share: "Teilen",
    fullscreen: "Vollbild",
    exitFullscreen: "Vollbild beenden",
    pathTrace: "Path Trace",
    pathTraceSettings: "Path-Trace-Einstellungen",
  },
  download3d: {
    defaultModel: "Modell",
    dialogLabel: "Anfrage zum Herunterladen des 3D-Modells",
    badge: "3D-Modell herunterladen",
    title: "Senden Sie uns eine Anfrage, um die Modelle zu nutzen.",
    subtitle: "Zur Nutzung in Plattformen wie 3ds Max, SketchUp und Revit.",
    configuration: "Konfiguration",
    notice:
      "Sobald Ihre Anfrage zum Modell-Download bestätigt wurde, werden Sie per E-Mail informiert.",
    supportedFormats: "Unterstützte Formate: FBX · GLB · BLEND",
    exportFormats: "Dateiformate",
    formatRequired: "Wählen Sie mindestens ein Dateiformat.",
    format: {
      fbx: "FBX (3ds Max, Maya)",
      glb: "GLB (glTF)",
      blend: "Blender (BLEND)",
    },
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    phoneCountryCode: "Telefon-Ländervorwahl",
    projectCountry: "Projektland",
    projectCity: "Projektstadt",
    selectCountry: "Land auswählen",
    selectCountryFirst: "Zuerst Land auswählen",
    cityPlaceholder: "Stadt eingeben",
    company: "Firma / Studio",
    note: "Notiz",
    submit: "Anfrage senden",
    verifyAndSubmit: "Verifizieren und Download-Anfrage senden",
    otpCode: "Bestätigungscode",
    otpTitle: "Bestätigungscode eingeben",
    otpPlaceholder: "000000",
    otpHint:
      "Geben Sie den 6-stelligen Code ein, der an Ihr Telefon gesendet wurde.",
    otpResend: "Neuen Code senden",
    otpBack: "Angaben bearbeiten",
    otpResendHint:
      'Tippen Sie auf "Neuen Code senden", um einen neuen Bestätigungscode zu erhalten.',
    otpRequired: "Bitte geben Sie den Bestätigungscode ein.",
    validationError: "Bitte füllen Sie alle Pflichtfelder aus.",
    unexpectedResponse: "Unerwartete Serverantwort.",
    rateLimit: "Zu viele Versuche. Bitte versuchen Sie es später erneut.",
    genericError:
      "Download-Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
    successTitle: "Ihre Download-Anfrage wurde empfangen",
    successSubtitle:
      "Sie werden per E-Mail benachrichtigt, sobald Ihre Anfrage genehmigt wurde.",
    successDismissHint: "Dieses Fenster schließt sich in wenigen Sekunden.",
  },
  quoteRequest: {
    dialogLabel: "Angebotsanfrage",
    badge: "Vorteilhafte Preise",
    title:
      "Senden Sie Ihre Anfrage, wir melden uns innerhalb eines Werktages bei Ihnen.",
    subtitle:
      "Wir teilen Ihnen schnell ein vorteilhaftes Angebot für Ihre Konfiguration mit.",
    quantity: "Menge",
    decreaseQuantity: "Menge verringern",
    increaseQuantity: "Menge erhöhen",
    details: "Anfragedetails",
    detailsPlaceholder: "Stoff, Farbe, Lieferzeit, besondere Hinweise...",
    submit: "Angebotsanfrage senden",
    contactMethod: "Verifizierungskanal",
    contactPhone: "Telefon (SMS)",
    contactEmail: "E-Mail",
    verifyAndSubmit: "Verifizieren und Anfrage senden",
    otpCode: "Verifizierungscode",
    otpTitle: "Verifizierungscode eingeben",
    otpPlaceholder: "000000",
    otpHint:
      "Geben Sie den 6-stelligen Code ein, der an den gewählten Kanal gesendet wurde.",
    otpResend: "Neuen Code senden",
    otpBack: "Angaben bearbeiten",
    otpResendHint:
      'Tippen Sie auf "Neuen Code senden", um einen neuen Bestätigungscode zu erhalten.',
    otpRequired: "Bitte geben Sie den Verifizierungscode ein.",
    validationError: "Bitte füllen Sie alle Pflichtfelder aus.",
    unexpectedResponse: "Unerwartete Serverantwort.",
    rateLimit: "Zu viele Versuche. Bitte versuchen Sie es später erneut.",
    genericError:
      "Angebotsanfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
    successTitle: "Ihre Angebotsanfrage wurde empfangen",
    successSubtitle: "Ihre Angebotsnummer:",
    successDismissHint: "Dieses Fenster schließt sich in wenigen Sekunden.",
  },
  roomQuote: {
    tip: "Angebot anfordern",
    sceneSummary: "Szenenprodukte",
    productsLabel: "Produkte in der Szene",
    emptyScene:
      "Fügen Sie mindestens ein Produkt zur Szene hinzu, bevor Sie ein Angebot anfordern.",
    categoryCountBlockedTitle: "Menge ist für ein Angebot nicht gültig",
    categoryCountBlocked:
      "Die Anzahl der {{category}}-Produkte in der Szene muss ein Vielfaches von {{multiple}} sein, bevor ein Angebot angefordert werden kann.",
    missingCompany:
      "Firmeninformationen fehlen. Bitte prüfen Sie den Katalog.",
    fullName: "Vor- und Nachname",
    phone: "Telefon",
    headline:
      "Drucken Sie Ihr Design oder fordern Sie ein Angebot zu vorteilhaften Preisen an.",
    submit: "Angebot anfordern",
    contactRequired: "Bitte geben Sie Namen und Telefonnummer ein.",
    draftSaved: "Ihre Angaben wurden gespeichert. Das Angebotsformular wird geöffnet…",
    sku: "SKU",
  },
  viewerApiErrors: {
    RATE_LIMIT: "Zu viele Versuche. Bitte versuchen Sie es später erneut.",
    ORIGIN_DENIED: "Diese Aktion ist von Ihrer Website aus nicht erlaubt.",
    CHANNEL_NOT_FOUND:
      "Dieser Dienst ist für das ausgewählte Unternehmen nicht konfiguriert.",
    VALIDATION_ERROR: "Bitte überprüfen Sie Ihre Eingaben.",
    OTP_FAILED: "Der Verifizierungscode ist ungültig oder abgelaufen.",
    ACCESS_DENIED: "Sie sind nicht berechtigt, diese Aktion auszuführen.",
    MISSING_PUBLIC_KEY: "Die Angebotsintegration ist nicht konfiguriert.",
    CRM_VALIDATION:
      "Die Anfrage konnte nicht verarbeitet werden. Bitte prüfen Sie Ihre Angaben.",
    NOT_FOUND: "Die angeforderte Ressource wurde nicht gefunden.",
    SERVICE_ERROR:
      "Der Dienst ist vorübergehend nicht verfügbar. Bitte erneut versuchen.",
    GENERIC_ERROR:
      "Der Vorgang konnte nicht abgeschlossen werden. Bitte erneut versuchen.",
  },
  ar: {
    exit: "AR beenden",
    hint: "Fläche suchen, Produkt ziehen und drehen",
    startedSearching: "AR gestartet — Fläche wird gesucht",
    preparingModel: "3D-Modell wird vorbereitet…",
    openInAr: "In AR öffnen",
    surfaceFound: "Fläche gefunden",
    productPlaced: "Produkt platziert",
    rotating: "Wird gedreht…",
    light: "Licht",
    depth: "Tiefe",
    checking: "Wird geprüft",
    capabilityChecking: "{{label}}-Unterstützung wird geprüft",
    capabilityOnTapToOff: "{{label}} ist aktiv, antippen zum Ausschalten",
    capabilityOffTapToOn: "{{label}} ist aus, antippen zum Einschalten",
    capabilityUnsupported:
      "{{label}} wird auf diesem Gerät/Browser nicht unterstützt",
    lightEstimationActive: "Lichtschätzung aktiv",
    lightEstimationOn: "Lichtschätzung eingeschaltet",
    lightEstimationOff: "Lichtschätzung ausgeschaltet",
    depthOcclusionActive: "Tiefenverdeckung aktiv",
    depthOcclusionOn: "Tiefenverdeckung eingeschaltet",
    depthOcclusionOff: "Tiefenverdeckung ausgeschaltet",
  },

  "Ahşap Seçeneği": "Holzoption",
  "Ayak Tipi": "Fußtyp",
  "Ayak Rengi": "Fußfarbe",
  "Ayak Seçeneği": "Fußvariante ",

  "Kumaş Seçeneği": "Stoffoptinen",
  "Kumaş Tipi": "Stofftyp",
  "Kumaş Rengi": "Stofffarbe",

  "Sırt Minderi Tipi": "Rückenkissen",
  "Sırt Tipi": "Rückenkissen",
  "Kol Tipi": "Armlehnenoption",

  "Kalın Kol": "Fett Arm",
  "İnce Kol": "Schmal Arm",

  "Rahat Dolgu": "Gefülltes Rückenkissen",
  "Kalıcı Form": "Block-Rückenkissen",

  "Klem Üçlü Modül": "Klem 3-Sitzer Module",
  "Klem İkili Modül": "Klem 2-Sitzer Module",
  "Klem Tekli Modül": "Klem Einsitzer Module",
  "Klem Tekli Large Modülü": "Klem Einstzer Grob Module",
  "Klem Loveseat Modülü": "Klem Loveseat Module",

  "Klem Köşe Modülü": "Klem Eck Module",
  "Klem Dinlenme Modülü": "Klem Recamiere Module",
  "Klem Puf": "Klem Hocker",
  "Klem Puf Small": "Klem Hocker Klein",
  "Klem Bench": "Klem Bank",

  "Muly Baş Desteği": "Muly Sofakopfstütze",
  "Modsy Berjer": "Modsy Akzentstuhl Holzbein",
  "Levy Meşe Berjer": "Levy Eiche Akzentstuhl",

  "Ahşap Ayak": "Koniche Holzbeine",
  "Silindir Ahşap Ayak": "Zylindrische Holzbeine",

  Açık: "Hell",
  Koyu: "Dunkel",
  Siyah: "Schwarz",

  "Doğal Doku": "Naturgewebe",
  Kadife: "Samt",
  Keten: "Gewebe",
  "Fitilli Kadife": "Cord Velours",
  Bukle: "Boucle",
  "Performans Kadife": "Gewebter Samt",
  "Performans Keten": "Performance-Stoff",

  Çakıl: "Kiesgrau",
  "Havacı Mavi": "Aviatorblau",
  "Beton Gri": "Betongrau",
  "Nil Yeşili": "Nilgrün",

  Füme: "Rauchgrau",
  Fildişi: "Elfenbein",
  "Mermer Gri": "Marmorgrau",
  "Galaksi Mavi": "Himmelsblau",
  Kaktüs: "Cactus",

  Haki: "Khaki",
  "Paslı Kırmızı": "Rostrot",
  "Gece Mavisi": "Mitternachtsblau",
  "Çağla Yeşili": "Mintgrün",
  Vanilya: "Vanille",
  Kiremit: "Ziegelrot",
  Gri: "Grau",
  "Zümrüt Yeşili": "Smaragdgrün",
  Hardal: "Senfgelb",
  Ekru: "Ecru",
  "Kül Gri": "Aschgrau",

  Kemik: "Knochen",
  "Polen Sarı": "Polengelb",
  "Sisli Yeşil": "Nebelgrün",
  "Sutlu Kahve": "Milchkaffee",
  Ziegelrot: "Ziegelrot",
  Grau: "Grau",
  Mavi: "Blau",

  "Deniz Köpüğü": "Meerschaum",
  Uzay: "Platz",

  Kehribar: "Schatz",
  Kum: "Eisblau",
  Bej: "Creme",
  "Yosun (Infinity 792": "Kieferngrün",
  Terra: "Kupfer",

  "Ada Çayı": "Salbeigrün",
  "Duman Gri": "Dunstiges Grau",
  Tuğla: "Terrakotta",

  "Klem İkili Gövde 154 Cm": "Klem 2-Sitzer Module 154 Cm",
  "Klem İkili Gövde 154 Cm Blok Sırt":
    "Klem 2-Sitzer Module 154 Cm Block Rücks",

  "Klem Üçlü Gövde 180 Cm": "Klem 3-Sitzer Module 180 Cm",
  "Klem Üçlü Gövde 180 Cm Blok Sırt": "Klem 3-Sitzer Module 180 Cm Block Rücks",
  "Klem Bench Gövde": "Klem Bank Module",
  "Klem Dinlenme Gövde": "Klem Recamiere Module",
  "Klem Dinlenme Gövde Blok Sırt": "Klem Recamiere Module Block Rücks",
  "Klem Kol Seti": "Klem Arm Set",
  "Modsy Kol Seti": "Modsy Arm Set",
  "Klem Köşe Gövde": "Klem Eck Module",
  "Klem Köşe Gövde Blok Sırt": "Klem Eck Module Block Rücks",
  "Klem Puf Gövde": "Klem Hocker Module",
  "Klem Puf Small Gövde": "Klem Hocker Klein Module",
  "Klem Tekli Gövde 100 Cm": "Klem Sessel Module 100 Cm",
  "Klem Tekli Gövde 100 Cm Blok Sırt": "Klem Sessel Module 100 Cm Block Rücks",
  "Klem Tekli Gövde 64 Cm Blok Sırt": "Klem Sessel Module 64 Cm Block Rücks",
  "Klem Tekli Gövde 77 Cm": "Klem Sessel Module 77 Cm",
  "Konik Ahşap Ayak 4lü Set": "Set mit 4 Holzbeinen",
  "Konik Ahşap Orta Ayak 2li Set": "Set mit 2 Stütz-holzbeinen",
  "Konik Dinlenme Ahşap Ayak 6lı Set": "Set mit 6 Holzbeinen",
  "Konik Ayak": "Conic",

  "Silindir Ahşap Ayak 4lü Set": "Set mit 4 Zylindrischen Holzbeinen",
  "Silindir Ahşap Orta Ayak 2li Set": "Set mit 2 Zylindrischen Stützbeinen",
  "Silindir Dinlenme Ahşap Ayak 6lı Set": "Set mit 6 Zylindrischen Holzbeinen",
  "18 Cm Silindir Dinlenme Ahşap Ayak 6lı Set": "Set mit 6 Holzbeinen",
  "18 Cm Ahşap Ayak 4lü Set": "Set mit 4 Holzbeinen",
  "18 Cm Ahşap Orta Ayak 2li Set": "Set mit 2 Stütz-holzbeinen",
  "18 Cm Dinlenme Ahşap Ayak 6lı Set": "Set mit 6 Zylindrischen Holzbeinen",
  "18 Cm Silindir Ahşap Ayak 4lü Set": "Set mit 4 Zylindrischen Holzbeinen",
  "18 Cm Silindir Ahşap Orta Ayak 2li Set":
    "Set mit 2 Zylindrischen Stützbeinen",

  "Dolgu Sırt Minderi": "Gefülltes Rückenkissen",
  "Blok Sırt Minderi": "Block-Rückenkissen",

  confirm: "Bestätigen",
  confirmshape: "Form aktualisieren",
  notFound: "Nicht gefunden",
  next: "Weiter",
  back: "Zurück",
  export: "Exportieren",
  gapWidth: "Spaltenbreite",
  wallWidth: "Wandbreite",
  balconyWidth: "Balkonbreite",
  clearAllTip: "Alles löschen",
  drawBalconyTip: "Balkon zeichnen",
  drawWallTip: "Wand zeichnen",
  selectToolTip: "Auswählen",
  drawGapTip: "Lücke zeichnen",
  downloadPdfTip: "Als PDF herunterladen",
  search: "Suchen",
  save: "Speichern",
  saveDisabledTip: "Speichern ist bald verfügbar",
  myRenders: "Meine Renderings",
  myRendersHint: "Ihre zuletzt erstellten Renderbilder",
  myRendersEmpty: "Noch keine gespeicherten Renderings. Erfassen Sie eine Ansicht im 3D-Modus.",
  myRendersCapture: "Ansicht hinzufügen",
  myRendersCapturing: "Wird hinzugefügt…",
  rendersTabMy: "Meine Renderings",
  rendersTabRapid: "RapidRender",
  rapidRendersEmpty: "Noch keine RapidRender-Bilder.",
  rapidRendersLoading: "Renderings werden geladen…",
  rapidRendersPending: "Wird gerendert…",
  rapidRendersError: "Rendering fehlgeschlagen.",
  rapidRendersLoadMore: "Mehr laden",
  renderCapture: "KI-Rendern",
  renderCapturing: "Wird gerendert…",
  aiRenderTitle: "KI-Rendern",
  aiRenderHint: "Beschreiben Sie den gewünschten Look und starten Sie das Rendering.",
  aiRenderPrompt: "Prompt",
  aiRenderPromptPlaceholder:
    "z. B. sanftes Tageslicht, warme Holztöne, gemütliches Wohnzimmer…",
  aiRenderResolution: "Auflösung",
  aiRenderPersonalize: "Personalisieren",
  aiRenderAddPlant: "Pflanze",
  aiRenderAddArtwork: "Kunstwerk",
  aiRenderAddDecor: "Dekor",
  aiRenderStart: "Rendering starten",
  aiRenderProgressTitle: "Rendering wird vorbereitet",
  aiRenderProgressWorking: "Wird verarbeitet…",
  aiRenderProgressBeauty: "Ansicht wird erfasst",
  aiRenderProgressAlbedo: "Albedo wird erfasst",
  aiRenderProgressTopView: "Draufsicht wird erfasst",
  aiRenderProgressNormal: "Normalen werden erfasst",
  aiRenderProgressDepth: "Tiefe wird erfasst",
  aiRenderProgressSend: "Wird an RapidRender gesendet",
  sceneAiTitle: "Szenen-KI",
  sceneAiSettings: "API-Einstellungen",
  sceneAiProvider: "Anbieter",
  sceneAiModel: "Modell",
  sceneAiSearchModel: "Modell suchen…",
  sceneAiNoModels: "Kein Treffer. Dieser Name kann trotzdem verwendet werden.",
  sceneAiApiKey: "API-Schlüssel",
  sceneAiEmpty: "Beschreiben Sie die Wohnung oder den Raum. Die KI platziert Grundriss, Zimmer und Möbel.",
  sceneAiPlaceholder: "z. B. 110 m², 2 Zimmer, offene Küche, Eingang von Süden…",
  sceneAiAttachImage: "Foto anhängen",
  sceneAiRemoveImage: "Foto entfernen",
  sceneAiDropImage: "Foto hier ablegen",
  sceneAiSend: "Senden",
  sceneAiSending: "Wird gesendet…",
  sceneAiNeedKey: "Bitte zuerst den API-Schlüssel in den Einstellungen eingeben.",
  sceneAiThinking: "Überlegung",
  sceneAiTool: "Werkzeug",
  sceneAiYes: "Ja, übernehmen",
  sceneAiNo: "Nein",
  sceneAiBrief: "Brief",
  sceneAiBriefHard: "Pflicht",
  sceneAiBriefSoft: "Wünsche",
  sceneAiBriefAssume: "Annahmen",
  sceneAiBriefUnknown: "Fragen",
  sceneAiBriefOpen: "offen",
  sceneAiBriefOk: "Erfüllt",
  sceneAiBriefFail: "Nicht erfüllt",
  sceneAiBriefUnchecked: "Nicht geprüft",
  authLoginTitle: "Anmelden",
  authLoginSubtitle: "Melden Sie sich an, um fortzufahren.",
  authEmail: "E-Mail",
  authPassword: "Passwort",
  authSignIn: "Anmelden",
  authSigningIn: "Anmeldung…",
  authCancel: "Abbrechen",
  authSelectCompany: "Unternehmen wählen",
  authErrorInvalid: "E-Mail oder Passwort ungültig.",
  authErrorRecaptcha: "Bitte bestätigen Sie, dass Sie kein Roboter sind.",
  authErrorGeneric: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
  authLogout: "Abmelden",
  authAccount: "Konto",
  pathTraceRender: "Rendern",
  download: "Herunterladen",
  share: "Teilen",
  close: "Schließen",
  //WelcomeMenu.tsx
  welcomeMenuWelcome: "Hallo! Willkommen beim Planer!",
  drawRoomShape: "Eigenen Raum zeichnen",
  chooseRoomShapeFromTemplates: "Aus Vorlagen wählen",
  chooseRoomShape: "Raumform wählen",
  //MainPane.tsx
  roomFeatures: "Resize",
  roomStyle: "Raumstil",
  door: {
    opensIn: "Nach innen öffnend",
    opensOut: "Nach außen öffnend",
    hingeStart: "Scharnier (Anfang)",
    hingeEnd: "Scharnier (Ende)",
    openAngle: "Öffnungswinkel",
  },
  structural: {
    menu: "Struktur",
    rectColumn: "Rechteckige Säule",
    roundColumn: "Runde Säule",
    beam: "Balken",
    radiator: "Heizkörper",
    pool: "Pool",
    width: "Breite",
    depth: "Tiefe",
    height: "Höhe",
    diameter: "Durchmesser",
    widthCm: "Breite (cm)",
    depthCm: "Tiefe (cm)",
    heightCm: "Höhe (cm)",
    diameterCm: "Durchmesser (cm)",
    columnHeightLocked: "Höhe auf Raumhöhe gesperrt",
    elevation: "Höhenlage",
    elevationCm: "Höhenlage (cm)",
    beamElevationHint: "Unterkante ab Fußboden. Beim Platzieren zunächst unter der Decke.",
    elevationHint: "Höhe ab Fußboden. In 3D mit Horizontal/Vertikal die Zugrichtung wählen.",
    moveMode: "Bewegen",
    moveHorizontal: "Horizontal",
    moveVertical: "Vertikal",
    moveGizmo: "Mit Achsen bewegen",
  },
  lighting: "Beleuchtung",
  settings: "Einstellungen",
  lengthUnit: "Maßeinheit",
  lengthUnitCm: "Zentimeter (cm)",
  lengthUnitMm: "Millimeter (mm)",
  lengthUnitInch: "Zoll (in)",
  hdrSelection: "HDR-Auswahl",
  hdrPreview: "HDR-Vorschau",
  renderSettings: "Darstellung",
  toneMapping: "Tonwertabbildung",
  disabled: "Aus",
  exposure: "Belichtung",
  environmentLight: "Umgebungslicht",
  aoMapIntensity: "AO-Map-Intensität",
  ambientOcclusion: "Umgebungsverdeckung",
  ssgi: "SSGI",
  ssgiHint:
    "Screen-Space GI + AO. Deaktiviert GTAO solange aktiv.",
  ssgiSparse: "SSGI Sparse",
  ssgiSparseHint:
    "Nur GI (kein AO). Stride-Raster; Zwischenpixel aus vier Nachbarn interpoliert.",
  ssgiOutput: "Ausgabe",
  ssgiOutputCombined: "Kombiniert",
  ssgiOutputDirect: "Direkt",
  ssgiOutputAo: "AO",
  ssgiOutputGi: "GI",
  ssgiOutputNormal: "Normale (MRT)",
  ssgiOutputDepth: "Tiefe",
  ssgiOutputGiDebug: "GI Debug",
  ssgiOutputGiSource: "GI-Quelle",
  gtaoHint: "Verfügbar wenn SSGI und Path Trace aus sind.",
  gtaoSamples: "Samples",
  gtaoScale: "Skala",
  gtaoDenoise: "Denoise",
  gtaoLumaPhi: "Luma Φ",
  gtaoDepthPhi: "Depth Φ",
  gtaoNormalPhi: "Normal Φ",
  gtaoPdRadius: "Denoise-Radius",
  distanceExponent: "Distanz-Exponent",
  distanceFallOff: "Distanz-Abnahme",
  resolutionScale: "Auflösungsskala",
  pixelRatioScale: "Auflösungsfaktor",
  pixelRatioScaleHint:
    "Wird mit dem devicePixelRatio des Browsers multipliziert. 1 = native Geräteauflösung. Kleinere Werte reduzieren die Schärfe und erhöhen die FPS.",
  imageQuality: "Bildqualität",
  qualitySmooth: "Flüssig",
  qualityBalanced: "Ausgewogen",
  qualitySharp: "Scharf",
  clarityHint: "Weniger Schärfe läuft flüssiger.",
  editLights: "Lichter bearbeiten",
  advancedDisplay: "Erweiterte Anzeige",
  settingsSectionEnvironment: "Umgebung",
  environmentFallback: "Umgebung",
  pathTraceHint:
    "Progressives Path Tracing (WebGL2-Sidecar). Deaktiviert SSGI / GTAO / TAA.",
  pathTraceFrameCount: "Path-Trace-Bilder",
  pathTraceRenderScale: "Render-Skala",
  pathTraceBounces: "Bounces",
  pathTraceSamplesPerFrame: "Samples / Frame",
  pathTraceFilterGlossy: "Glanzfilter",
  pathTraceFadeDuration: "Überblendung (ms)",
  sliceCount: "Slice-Anzahl",
  stepCount: "Schrittanzahl",
  giIntensity: "GI-Intensität",
  aoIntensity: "AO-Intensität",
  thickness: "Dicke",
  expFactor: "Exp-Faktor",
  backfaceLighting: "Rückseitenbeleuchtung",
  useLinearThickness: "Lineare Dicke",
  useScreenSpaceSampling: "Screen-Space-Sampling",
  useTemporalFiltering: "Temporale Filterung",
  giStride: "GI-Stride",
  giAdaptive: "GI-Adaptiv",
  giAdaptiveOff: "Aus",
  giAdaptiveEdge: "Kante",
  giAdaptiveRefine: "Refine",
  giAdaptiveRefineHint:
    "Voll-GI in groben Zellen, deren 9 Depth/Normal-Taps nicht übereinstimmen. Nutzt die Tiefen- und Normalen-Schwellen darunter.",
  giEdgeThickness: "GI-Kantenstärke",
  giEdgeKernel: "GI-Kantenkernel",
  giEdgeKernelCross: "Kreuz (4 Tap)",
  giEdgeKernelSobel: "Sobel",
  giEdgeKernelPrewitt: "Prewitt",
  giEdgeKernelScharr: "Scharr",
  giEdgeThreshold: "GI-Kantenschwelle",
  giDepthThreshold: "GI-Tiefen-Schwelle",
  giNormalThreshold: "GI-Normalen-Schwelle",
  giMinOkCount: "Min. gültige Taps",
  ssgiSparseVersion: "Version",
  ssgiSparseVersionV1: "v1 (alt)",
  ssgiSparseVersionV2: "v2 (mit Verlauf)",
  ssgiSparseV2Hint:
    "GI + AO. Pro Zelle wird ein Pixel verfolgt, jedes Bild ein anderes; nur GI wird akkumuliert, neu sichtbare Bereiche werden geglättet.",
  giHistoryLength: "Verlaufslänge (Bilder)",
  giDenoisePasses: "Glättungsdurchläufe",
  giEdgeRefine: "Kanten zusätzlich verfolgen",
  intensity: "Intensität",
  radius: "Radius",
  raySamples: "Strahlen-Samples",
  accumulation: "Akkumulation",
  denoise: "Entrauschen",
  sampleLevel: "Sample-Stufe",
  unbiased: "Unverzerrtes Sampling",
  settingsSectionDisplay: "Anzeige",
  settingsSectionLighting: "Beleuchtung",
  settingsSectionColor: "Farbe",
  antialias: "Anti-Aliasing",
  antialiasSamples: "AA-Samples",
  fxaa: "FXAA",
  msaa: "MSAA",
  msaaSamples: "MSAA-Samples",
  shadows: "Schatten",
  shadowQuality: "Schattenqualität",
  qualityLow: "Niedrig",
  qualityMedium: "Mittel",
  qualityHigh: "Hoch",
  resetRenderSettings: "Darstellungseinstellungen zurücksetzen",
  fullReset: "Alles zurücksetzen",
  help: "Hilfe",
  volumeDebug: "Volumen",
  cornerLineSnap: "Eckenausrichtung",
  volumeDebugCollision: "Kollision (beim Ziehen)",
  volumeDebugObb: "OBB",
  volumeDebugAabb: "Bounding-Box",
  volumeDebugHint:
    "OBB hat zwei Farben: Teile und Hülle. Kollision nutzt die Kontaktfarbe. Die Weltbox bleibt achsparallel.",
  volumeDebugColorParts: "Teilefarbe",
  volumeDebugColorHull: "Hüllenfarbe",
  volumeDebugColorContact: "Kontaktfarbe",
  volumeDebugColorAabb: "Weltboxfarbe",
  appMode: "Modus",
  liveMode: "Live",
  devMode: "Dev",
  usageTips: "Bedienhinweise",
  restartTour: "Tour neu starten",
  tips: {
    doneBtnText: "Verstanden",
    dontShowAgain: "Nicht mehr anzeigen",
  },
  start: "Starten",
  roomLights: "Raumbeleuchtung",
  roomLightsLoading: "Raumbeleuchtung wird vorbereitet…",
  height: "Höhe",
  spacing: "Abstand",
  distance: "Reichweite",
  decay: "Abklingrate",
  color: "Farbe",
  roomLightShadows: "Schatten der Raumbeleuchtung",
  automatic: "Automatisch",
  reset: "Zurücksetzen",
  lightCount: "Lichter",
  wallColor: "Wandfarbe",
  floorColor: "Bodenfarbe",
  ceilingColor: "Deckenfarbe",
  windowColor: "Fensterfarbe",
  doorColor: "Türfarbe",
  surfaceWall: "Wand",
  surfaceFloor: "Boden",
  surfaceCeiling: "Decke",
  surfaceWindow: "Fenster",
  surfaceDoor: "Tür",
  chooseFromColorPalette: "Aus Farbpalette wählen",
  chooseFromColorPaletteHint: "Eigene Farbe aus dem Spektrum wählen",
  floorMaterials: "Bodenbelag",
  floorMatParquet01: "Parkett 01",
  floorMatParquet02: "Parkett 02",
  floorMatParquet03: "Parkett 03",
  floorMatParquet04: "Parkett 04",
  floorMatParquet05: "Parkett 05",
  floorMatParquet06: "Parkett 06",
  floorMatParquet07: "Parkett 07",
  floorMatParquet08: "Parkett 08",
  floorMatParquet09: "Parkett 09",
  floorMatParquet10: "Parkett 10",
  floorMatParquet11: "Parkett 11",
  floorMatParquet12: "Parkett 12",
  floorMatParquet13: "Parkett 13",
  floorMatParquet14: "Parkett 14",
  floorMatParquet15: "Parkett 15",
  floorMatParquet16: "Parkett 16",
  floorMatParquet17: "Parkett 17",
  floorMatParquet18: "Parkett 18",
  floorMatParquet19: "Parkett 19",
  floorMatParquet20: "Parkett 20",
  floorMatParquet21: "Parkett 21",
  floorMatParquet22: "Parkett 22",
  floorMatOakParquet: "Eichenparkett",
  floorMatWalnutParquet: "Nussbaumparkett",
  floorMatAshParquet: "Eschenparkett",
  floorMatHoneyOak: "Honigeiche",
  floorMatDarkOak: "Dunkle Eiche",
  floorMatCherryParquet: "Kirschparkett",
  floorMatTeakParquet: "Teakparkett",
  floorMatSmokedOak: "Geräucherte Eiche",
  floorMatOakHerringbone: "Eiche Fischgrät",
  floorMatWalnutHerringbone: "Nussbaum Fischgrät",
  floorMatOakWidePlank: "Eiche Landhausdiele",
  floorMatWalnutWidePlank: "Nussbaum Landhausdiele",
  floorMatAshWashedPlank: "Gewaschene Esche",
  floorMatOakChevron: "Eiche Chevron",
  floorMatBleachedOak: "Gebleichte Eiche",
  floorMatSilverWashedOak: "Silbergrau gewaschene Eiche",
  floorMatWarmOak: "Warme Eiche",
  floorMatBeigeGeoPanel: "Beige geometrisches Panel",
  floorMatCharcoalGeoPanel: "Anthrazit geometrisches Panel",
  floorMatTravertineBeige: "Beiger Travertin",
  floorMatWhiteMarble: "Weißer Marmor",
  floorMatCarraraMarble: "Carrara-Marmor",
  floorMatGrayMarble: "Grauer Marmor",
  floorMatBlackMarble: "Schwarzer Marmor",
  floorMatCalacattaMarble: "Calacatta-Marmor",
  floorMatVerdeMarble: "Verde-Marmor",
  floorMatTravertineMarble: "Travertin",
  floorMatRossoMarble: "Rosso-Marmor",
  floorMatLightTile: "Helle Fliese",
  floorMatGrayTile: "Graue Fliese",
  floorMatTerracottaTile: "Terrakotta-Fliese",
  floorMatConcrete: "Beton",
  floorMatGrass: "Rasen",
  newSceneTip: "Neue Szene",
  newSceneConfirmTitle: "Neue Szene erstellen?",
  newSceneConfirmBody: "Die aktuelle Szene wird vollständig geleert.",
  newSceneConfirm: "Szene leeren",
  selectFabricFromList: "Stoff aus der Liste wählen",
  sku: "SKU",
  cancelAction: "Abbrechen",
  deleteSelectionTip: "Auswahl löschen",
  drawWall: "Vorlagen",
  showReport: "Angebot",
  addToRoom: "Produkte",
  authorizedCatalogUnauthorized: "Anmeldung erforderlich.",
  authorizedCatalogEmpty: "Keine Ergebnisse.",
  authorizedCatalogLoadMore: "Mehr laden",
  authorizedFacetCatalogs: "Kataloge",
  authorizedFacetCategories: "Kategorien",
  authorizedFacetTypeCategories: "Typkategorien",
  authorizedFacetCollections: "Kollektionen",
  authorizedClearFacets: "Zurücksetzen",
  authorizedFilters: "Filter",
  authorizedChooseFilterHint:
    "Wählen Sie Katalog oder Kategorie über das Filtersymbol.",
  authorizedProductsTitle: "Produkte",
  authorizedHideProducts: "Produkte ausblenden",
  cameraView: "Ansicht",
  cameraViewTop: "Oben",
  cameraViewLeft: "Links",
  cameraViewRight: "Rechts",
  cameraViewTopHint: "Von oben betrachten",
  cameraViewLeftHint: "Von der Seite betrachten",
  cameraViewRightHint: "Von vorn betrachten",
  configure: "Konfigurieren",
  //RoomShaping.tsx
  changeRoomShape: "Raumform ändern",
  roomShapeStartMessage: "Mit fertigen Raumvorlagen starten",
  selectRoomTemplate: "Vorlage wählen",
  drawFromScratch: "Von Grund auf zeichnen",
  newRoom: "Löschen",
  roomShapeOnlyFloor: "Ohne Wände",
  roomShapeFloorWithSingleWall: "Einzelne Wand",
  roomShapeCorner: "Ecke",
  roomDoubleBalcony: "Eckform",
  roomShapeRectangle: "Rechteck",
  roomShapeSquare: "Quadrat",
  roomShapeLShape: "L-Form",
  roomShapeZShape: "Z-Form",
  roomShapeUShape: "U-Form",
  roomShapeTShape: "T-Form",
  roomShape5Sides: "5-seitig",
  roomShapeBevelShape: "Abgeschrägte Form",
  //RoomModifying.tsx
  wallResize: "Wände skalieren",
  glassPriceMultiplier: "Glaspreis pro Meter",
  basePriceMultiplier: "Basispreis pro Einheit",
  buyerName: "Käufername",
  dimensions: "Abmessungen",
  resetArea: "Bereich zurücksetzen",
  undo: "Rückgängig",
  redo: "Wiederholen",
  topView: "Draufsicht",
  calculating: "Wird berechnet...",
  loading: "Wird geladen...",
  productList: "Produktliste",
  pdfReport: {
    defaultProjectName: "design-zusammenfassung",
    designReport: "Designbericht",
    designSummary: "Ihre Designzusammenfassung",
    downloadPdf: "PDF",
    print: "Drucken",
    share: "Teilen",
    requestQuote: "Angebot anfordern",
    close: "Schließen",
    downloaded: "PDF wurde heruntergeladen.",
    contentNotFound: "Berichtsinhalt wurde nicht gefunden",
    screenshotUnavailable: "Screenshot konnte nicht erstellt werden",
    addImage: "Bild hinzufügen",
    capturingViews: "Ansichten werden vorbereitet…",
    removeImage: "Bild entfernen",
    pickImage: "Bild auswählen",
    products: "Produkte",
    image: "Bild",
    code: "Code",
    sizeCm: "Größe (cm)",
    noProducts: "Keine Produkte gefunden",
    shareUnavailable: "Kein Bild zum Teilen verfügbar.",
    buyerInfo: "KÄUFERINFORMATIONEN",
    phoneLabel: "TELEFON",
    address: "ADRESSE",
    billingAddress: "RECHNUNGSADRESSE",
    billingSameAsCustomer:
      "Die Rechnungsadresse ist mit der Kundenadresse identisch.",
    sectionOne: "Abschnitt 1",
    colIndex: "#",
    colProduct: "Produkt",
    colQty: "Menge",
    colUnit: "Einheit",
    unitPiece: "Stk",
    colCustomized: "Angepasst",
    colDiscount: "Rabatt",
    colGrandTotal: "Gesamtsumme",
    currency: "Währung",
    emptyValue: "—",
  },
  proforma: {
    modelSummary: "Normod Zusammenfassung",
    pdfGenerating: "PDF wird erstellt...",
    pdfLibraryError: "PDF-Bibliothek konnte nicht geladen werden",
    pdfError:
      "PDF konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
    pdfError2:
      "Beim Erstellen des PDFs ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    offerNo: "Angebotsnummer",
    quantity: "Menge",
    product: "Produkt",
    price: "Preis",
    subtotal: "Zwischensumme",
    dimensions: "Abmessungen",
    materialType: "Materialtyp",
    materialColor: "Materialfarbe",
    orderDate: "Bestelldatum",
    discount: "Rabatt",
    taxIncluded: "Steuer (inkl.) MwSt-10%",
    total: "GESAMTSUMME",
    footer1: "Unsere Preise enthalten die Mehrwertsteuer.",
    footer2: "Die Preise gelten für den Tag der Erstellung des Formulars.",
    footer3:
      "Dieses Formular dient nur zu Angebotszwecken und kann nicht für Bestellungen verwendet werden.",
    footer4:
      "Dieses Design wurde speziell für die Person am {{date}} erstellt.",
    footer5:
      "Unsere Produkte sind auf Komfort ausgelegt. Da reichhaltige Fasern und hochelastische Premium-Schwämme verwendet werden, können Nähte unregelmäßig sein.",
    footer6: "Die Farben auf dem Bildschirm können abweichen.",
    footer7: "Die Gültigkeitsdauer des Angebots beträgt 3 Tage.",
    preview3d: "3D Vorschau",
    setProjectName: "Projektnamen festlegen",
    pdfWillBeSavedAs: "Die PDF-Datei wird mit diesem Namen gespeichert",
    projectName: "Projektname",
    projectNamePlaceholder: "z.B. Küchendesign",
    cancel: "Abbrechen",
    createPdf: "PDF erstellen",
    priceAsc: "Preis ↑",
    priceDesc: "Preis ↓",
    sort: "Sortieren",
    productDetails: "Produktdetails",
    cm: "cm",
    addToCart: "In den Warenkorb",
    share: "Teilen",
  },
  side: {
    backCushion: "Rückenkissen",
    armOption: "Armlehnenoption",
    fabricDetails: "Stoffdetails",
    apply: "Anwenden",
    materialGroupDescription:
      "Wähle aus den gefundenen Stoffarten und wähle deine gewünschte Farbe aus der Untergruppe, um dein Produkt zu individualisieren.",
  },
};
